import React from 'react';
import { 
  Menu, 
  X
} from 'lucide-react';

const Navigation = ({ 
  language, 
  currentContent, 
  isMenuOpen, 
  setIsMenuOpen, 
  scrollToSection, 
  toggleLanguage 
}) => {
  return (
    <nav className="fixed top-0 w-full bg-white/90 backdrop-blur-md shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img 
              src="/assets/logo-casa-colores-tilcara-hostel.jpg" 
              alt="Casa Colores Hostel Tilcara" 
              className="h-10 w-auto rounded-lg"
            />
            <span className="font-bold text-xl text-gray-900">Casa Colores</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {Object.entries(currentContent.nav).map(([key, value]) => (
                <button
                  key={key}
                  onClick={() => scrollToSection(key)}
                  className="text-gray-700 hover:text-tilcara-orange px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
                >
                  {value}
                </button>
              ))}
            </div>
          </div>

          {/* Language Toggle & Mobile Menu */}
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 text-gray-700 hover:text-tilcara-orange transition-colors duration-200 bg-white/50 rounded-lg px-3 py-2 backdrop-blur-sm border border-gray-200 hover:border-tilcara-orange"
            >
              <div className="w-6 h-4 rounded-sm overflow-hidden border border-gray-300">
                {language === 'es' && <img src="/assets/flags/argentina.svg?v=2.0" alt="Argentina" className="w-full h-full object-cover"/>}
                {language === 'en' && <img src="/assets/flags/usa.svg?v=2.0" alt="USA" className="w-full h-full object-cover"/>}
                {language === 'pt' && <img src="/assets/flags/brasil.svg?v=2.0" alt="Brasil" className="w-full h-full object-cover"/>}
                {language === 'fr' && <img src="/assets/flags/france.svg?v=2.0" alt="France" className="w-full h-full object-cover"/>}
              </div>
              <span className="text-sm font-medium">{language.toUpperCase()}</span>
            </button>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-tilcara-orange"
              >
                {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
            {Object.entries(currentContent.nav).map(([key, value]) => (
              <button
                key={key}
                onClick={() => scrollToSection(key)}
                className="text-gray-700 hover:text-tilcara-orange block px-3 py-2 rounded-md text-base font-medium w-full text-left"
              >
                {value}
              </button>
            ))}
            {/* Language selector in mobile menu */}
            <div className="pt-2 border-t border-gray-200">
              <button
                onClick={toggleLanguage}
                className="flex items-center space-x-3 text-gray-700 hover:text-tilcara-orange px-3 py-2 rounded-md text-base font-medium w-full text-left bg-gray-50"
              >
                <div className="w-8 h-5 rounded-sm overflow-hidden border border-gray-300">
                  {language === 'es' && <img src="/assets/flags/argentina.svg?v=2.0" alt="Argentina" className="w-full h-full object-cover"/>}
                  {language === 'en' && <img src="/assets/flags/usa.svg?v=2.0" alt="USA" className="w-full h-full object-cover"/>}
                  {language === 'pt' && <img src="/assets/flags/brasil.svg?v=2.0" alt="Brasil" className="w-full h-full object-cover"/>}
                  {language === 'fr' && <img src="/assets/flags/france.svg?v=2.0" alt="France" className="w-full h-full object-cover"/>}
                </div>
                <span>{language.toUpperCase()}</span>
                <span className="text-sm text-gray-500">
                  {language === 'es' && 'Español'}
                  {language === 'en' && 'English'}
                  {language === 'pt' && 'Português'}
                  {language === 'fr' && 'Français'}
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
